import React from 'react';

import PropTypes from 'prop-types';

const USAState = (props) => {
    const {
        dimensions,
        fill,
        state,
        onClickState,
        stateName,
    } = props;

    return (
        <path d={dimensions} fill={fill} data-name={state} className={`${state} state`} onClick={onClickState}>
            <title>{stateName}</title>
        </path>
    );
};

USAState.propTypes = {
    dimensions: PropTypes.string.isRequired,
    fill: PropTypes.string,
    state: PropTypes.string,
    onClickState: PropTypes.func,
    stateName: PropTypes.string,
};

export default USAState;
